import { LegalPage } from './LegalPage'

export function CGUPage() {
  return (
    <LegalPage
      title="Conditions Générales d'Utilisation"
      subtitle="Version 1.0 — Entrée en vigueur : 15 mars 2026 — Applicables à tous les utilisateurs"
    >
      <h2>Article 1 — Identification de l'éditeur</h2>
      <p>La plateforme TremorApp, accessible à l'adresse https://app.tremorapp.net et https://www.tremor.fr (ci-après "le Service" ou "TremorApp"), est éditée par :</p>
      <table>
        <thead><tr><th>Information</th><th>Valeur</th></tr></thead>
        <tbody>
          <tr><td>Raison sociale</td><td>TremorApp SAS (à compléter)</td></tr>
          <tr><td>Forme juridique</td><td>Société par actions simplifiée</td></tr>
          <tr><td>Capital social</td><td>À compléter</td></tr>
          <tr><td>Siège social</td><td>À compléter — France</td></tr>
          <tr><td>SIRET</td><td>À compléter</td></tr>
          <tr><td>Numéro TVA intracommunautaire</td><td>À compléter</td></tr>
          <tr><td>Directeur de la publication</td><td>Victor Calvary</td></tr>
          <tr><td>Email de contact</td><td>legal@tremor.fr</td></tr>
          <tr><td>Hébergement</td><td>Hetzner Online GmbH, Industriestr. 25, 91710 Gunzenhausen, Allemagne</td></tr>
        </tbody>
      </table>

      <h2>Article 2 — Objet et champ d'application</h2>
      <p>Les présentes Conditions Générales d'Utilisation (ci-après "CGU") ont pour objet de définir les modalités et conditions dans lesquelles TremorApp met à disposition des utilisateurs son service de Market Intelligence à destination des agences marketing et professionnels du marketing digital.</p>
      <p>Les présentes CGU s'appliquent à :</p>
      <ul>
        <li>Tout utilisateur créant un compte sur la plateforme TremorApp</li>
        <li>Tout utilisateur accédant au Service, y compris en mode démo</li>
        <li>Tout administrateur de workspace TremorApp</li>
        <li>Tout membre invité à rejoindre un workspace existant</li>
      </ul>
      <p>L'utilisation du Service implique l'acceptation pleine et entière des présentes CGU. Si l'utilisateur n'accepte pas les présentes CGU, il doit s'abstenir d'utiliser le Service.</p>

      <h2>Article 3 — Description du Service</h2>
      <p>TremorApp est une plateforme SaaS (Software as a Service) de Market Intelligence composée de quatre modules :</p>
      <table>
        <thead><tr><th>Module</th><th>Sigle</th><th>Description</th></tr></thead>
        <tbody>
          <tr><td>Local Lead Radar</td><td>LLR</td><td>Surveillance des tendances de recherche locales et détection de pics de demande en temps réel</td></tr>
          <tr><td>Google Footprint Optimizer</td><td>GFO</td><td>Analyse SEO, gestion des avis Google Business Profile et recommandations de visibilité</td></tr>
          <tr><td>Auto Reputation Engine</td><td>ARE</td><td>Automatisation des campagnes de collecte d'avis clients et gestion de l'e-réputation</td></tr>
          <tr><td>Search Demand Intelligence</td><td>SDI</td><td>Analyse de marchés SEA, calcul du taux de capture et simulation budgétaire</td></tr>
        </tbody>
      </table>
      <p>TremorApp se réserve le droit de modifier, suspendre ou interrompre tout ou partie du Service à tout moment, avec ou sans préavis, sans que cela puisse engager sa responsabilité.</p>

      <h2>Article 4 — Création de compte et accès au Service</h2>
      <h3>4.1 Conditions d'éligibilité</h3>
      <p>Le Service est exclusivement destiné aux professionnels (personnes physiques agissant dans le cadre de leur activité professionnelle ou personnes morales). L'utilisation du Service par des consommateurs particuliers est exclue.</p>
      <p>Pour créer un compte, l'utilisateur doit :</p>
      <ul>
        <li>Être âgé d'au moins 18 ans</li>
        <li>Agir en qualité de professionnel</li>
        <li>Fournir des informations exactes, complètes et à jour</li>
        <li>Disposer d'une adresse email professionnelle valide</li>
      </ul>

      <h3>4.2 Processus de création de compte</h3>
      <p>La création d'un compte peut s'effectuer via trois méthodes :</p>
      <ul>
        <li>Inscription directe avec email et mot de passe</li>
        <li>Authentification unique (SSO) via Google Workspace</li>
        <li>Authentification unique (SSO) via Microsoft 365</li>
      </ul>
      <p>L'utilisateur garantit l'exactitude des informations fournies lors de la création de son compte. Toute fausse déclaration engage sa seule responsabilité.</p>

      <h3>4.3 Sécurité des identifiants</h3>
      <p>L'utilisateur est seul responsable de la confidentialité de ses identifiants de connexion. Il s'engage à notifier immédiatement TremorApp de toute utilisation non autorisée de son compte à l'adresse security@tremor.fr. TremorApp ne saurait être tenu responsable de toute perte ou dommage résultant du non-respect de cette obligation.</p>

      <h2>Article 5 — Utilisation acceptable du Service</h2>
      <h3>5.1 Comportements autorisés</h3>
      <ul>
        <li>Utiliser le Service dans le cadre de son activité professionnelle</li>
        <li>Créer autant de Radars, marchés et campagnes que le permet son abonnement</li>
        <li>Exporter les données générées par le Service</li>
        <li>Partager le Service avec les membres de son workspace dans les limites de son plan</li>
      </ul>

      <h3>5.2 Comportements interdits</h3>
      <ul>
        <li>Utiliser le Service à des fins illicites ou contraires aux présentes CGU</li>
        <li>Tenter d'accéder sans autorisation à des zones restreintes du Service</li>
        <li>Procéder à une ingénierie inverse, décompiler ou désassembler le Service</li>
        <li>Copier, reproduire, distribuer ou revendre tout ou partie du Service sans autorisation écrite</li>
        <li>Utiliser le Service pour envoyer des communications non sollicitées (spam)</li>
        <li>Contourner les mécanismes de sécurité du Service</li>
        <li>Utiliser des robots, scrapers ou tout autre outil automatisé non autorisé</li>
        <li>Usurper l'identité d'un autre utilisateur ou d'un tiers</li>
        <li>Partager ses identifiants avec des tiers non membres de son workspace</li>
      </ul>

      <h2>Article 6 — Données personnelles et RGPD</h2>
      <h3>6.1 Responsable de traitement</h3>
      <p>TremorApp SAS agit en qualité de Responsable de traitement pour les données personnelles des utilisateurs collectées dans le cadre du Service.</p>

      <h3>6.2 Données collectées</h3>
      <table>
        <thead><tr><th>Catégorie</th><th>Finalité</th><th>Base légale</th><th>Conservation</th></tr></thead>
        <tbody>
          <tr><td>Données d'identification (nom, email)</td><td>Gestion du compte utilisateur</td><td>Exécution du contrat</td><td>Durée du contrat + 3 ans</td></tr>
          <tr><td>Données de connexion (IP, navigateur)</td><td>Sécurité et prévention des fraudes</td><td>Intérêt légitime</td><td>12 mois</td></tr>
          <tr><td>Données d'usage (actions, clics)</td><td>Amélioration du Service</td><td>Intérêt légitime</td><td>24 mois</td></tr>
          <tr><td>Données de facturation</td><td>Gestion des paiements</td><td>Obligation légale</td><td>10 ans (comptabilité)</td></tr>
          <tr><td>Données des contacts importés (ARE)</td><td>Exécution des campagnes ARE</td><td>Consentement</td><td>Durée du compte + 30 jours</td></tr>
        </tbody>
      </table>

      <h3>6.3 Droits des personnes concernées</h3>
      <p>Conformément au Règlement (UE) 2016/679 (RGPD) et à la loi Informatique et Libertés, tout utilisateur dispose des droits suivants :</p>
      <ul>
        <li>Droit d'accès à ses données personnelles</li>
        <li>Droit de rectification des données inexactes</li>
        <li>Droit à l'effacement (droit à l'oubli)</li>
        <li>Droit à la limitation du traitement</li>
        <li>Droit à la portabilité des données</li>
        <li>Droit d'opposition au traitement</li>
        <li>Droit de retirer son consentement à tout moment</li>
      </ul>
      <p>Pour exercer ces droits : privacy@tremor.fr. En cas de réclamation non résolue, saisir la CNIL (www.cnil.fr).</p>

      <h3>6.4 Transferts de données</h3>
      <p>Les données des utilisateurs sont hébergées en Europe (Hetzner, Allemagne). TremorApp s'engage à ne pas transférer de données personnelles hors de l'Espace Économique Européen sans garanties appropriées conformément au RGPD.</p>

      <h3>6.5 Sous-traitants</h3>
      <table>
        <thead><tr><th>Sous-traitant</th><th>Pays</th><th>Finalité</th><th>Garanties</th></tr></thead>
        <tbody>
          <tr><td>Hetzner Online GmbH</td><td>Allemagne (UE)</td><td>Hébergement infrastructure</td><td>Clauses contractuelles types</td></tr>
          <tr><td>Stripe Inc.</td><td>États-Unis</td><td>Traitement des paiements</td><td>Certification PCI DSS L1 + Clauses types</td></tr>
          <tr><td>Google LLC</td><td>États-Unis</td><td>SSO Google + APIs</td><td>DPA Google + Clauses types</td></tr>
          <tr><td>Microsoft Corporation</td><td>États-Unis</td><td>SSO Microsoft</td><td>DPA Microsoft + Clauses types</td></tr>
        </tbody>
      </table>

      <h2>Article 7 — Propriété intellectuelle</h2>
      <p>TremorApp est titulaire de l'ensemble des droits de propriété intellectuelle relatifs au Service, incluant notamment :</p>
      <ul>
        <li>Le code source de la plateforme (frontend et backend)</li>
        <li>Les algorithmes de calcul (modèle d'élasticité SDI, score d'intensité LLR)</li>
        <li>Les interfaces graphiques, le design system et les éléments visuels</li>
        <li>La marque "TremorApp", le logo Ondes Concentriques et les éléments d'identité visuelle</li>
        <li>La documentation, les guides et les contenus du TremorWiki</li>
      </ul>
      <p>Aucune disposition des présentes CGU ne saurait être interprétée comme une cession de droits de propriété intellectuelle au profit de l'utilisateur.</p>
      <p>Les données générées par l'utilisateur dans le cadre de son utilisation du Service restent la propriété de l'utilisateur. TremorApp s'engage à les restituer à première demande dans un format standard (CSV/JSON) et à les supprimer dans les 30 jours suivant la résiliation du compte.</p>

      <h2>Article 8 — Disponibilité et niveaux de service</h2>
      <table>
        <thead><tr><th>Indicateur</th><th>Engagement</th><th>Mesure</th></tr></thead>
        <tbody>
          <tr><td>Disponibilité (uptime)</td><td>99,5% mensuel hors maintenance planifiée</td><td>Calculée sur le mois civil</td></tr>
          <tr><td>Maintenance planifiée</td><td>Préavis minimum 48h (sauf urgence)</td><td>Notification email + in-app</td></tr>
          <tr><td>Temps de réponse support</td><td>24h ouvrées (Pro) / 72h (Starter)</td><td>Tickets support</td></tr>
          <tr><td>Rétention des données</td><td>Données conservées 30 jours après résiliation</td><td>Export disponible avant expiration</td></tr>
        </tbody>
      </table>
      <p>En cas d'indisponibilité dépassant l'engagement mensuel, l'utilisateur peut demander un avoir calculé proportionnellement à la durée d'indisponibilité effective, dans la limite d'un mois d'abonnement.</p>

      <h2>Article 9 — Limitation de responsabilité</h2>
      <p>Dans les limites autorisées par la loi applicable, TremorApp ne saurait être tenu responsable :</p>
      <ul>
        <li>Des pertes de revenus, de clientèle ou d'opportunités commerciales de l'utilisateur</li>
        <li>De l'exactitude ou de l'exhaustivité des données provenant de sources tierces (Google Ads, GSC, SEMrush)</li>
        <li>Des interruptions de service dues à des causes extérieures (force majeure, pannes d'opérateurs tiers)</li>
        <li>Des conséquences des décisions prises par l'utilisateur sur la base des analyses du Service</li>
        <li>Des pertes de données résultant d'une utilisation non conforme du Service</li>
      </ul>
      <p>La responsabilité totale de TremorApp est limitée au montant des sommes effectivement payées par l'utilisateur au cours des 12 mois précédant le fait générateur.</p>
      <div className="note">Les résultats affichés par TremorApp sont des estimations basées sur des données publiques et des modèles analytiques. Ils ne constituent pas des garanties de performance.</div>

      <h2>Article 10 — Résiliation et suspension</h2>
      <h3>10.1 Résiliation par l'utilisateur</h3>
      <p>L'utilisateur peut résilier son compte à tout moment depuis les Paramètres de son workspace. La résiliation prend effet à la fin de la période d'abonnement en cours. Aucun remboursement prorata temporis n'est effectué sauf disposition contraire dans les CGV.</p>

      <h3>10.2 Résiliation ou suspension par TremorApp</h3>
      <p>TremorApp se réserve le droit de suspendre ou résilier l'accès au Service dans les cas suivants :</p>
      <ul>
        <li>Violation des présentes CGU</li>
        <li>Non-paiement des sommes dues</li>
        <li>Utilisation du Service à des fins frauduleuses ou illicites</li>
        <li>Atteinte à la sécurité ou à l'intégrité du Service</li>
      </ul>

      <h3>10.3 Effets de la résiliation</h3>
      <p>À la date effective de résiliation, l'utilisateur perd l'accès au Service. Ses données sont conservées 30 jours supplémentaires puis définitivement supprimées, sauf obligation légale de conservation.</p>

      <h2>Article 11 — Cookies</h2>
      <p>TremorApp utilise des cookies strictement nécessaires au fonctionnement du Service (authentification, préférences de session) et des cookies analytiques (mesure d'audience anonymisée). Aucun cookie publicitaire ou de tracking tiers n'est utilisé sur les produits TremorApp.</p>

      <h2>Article 12 — Modification des CGU</h2>
      <p>TremorApp se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront notifiés des modifications substantielles par email et via une notification in-app au moins 30 jours avant leur entrée en vigueur.</p>

      <h2>Article 13 — Droit applicable et juridiction compétente</h2>
      <p>Les présentes CGU sont soumises au droit français. En cas de litige, les parties s'engagent à rechercher une solution amiable avant tout recours judiciaire.</p>
      <p>À défaut d'accord amiable dans un délai de 30 jours, tout litige sera soumis à la compétence exclusive des tribunaux de Rennes (France).</p>
      <div className="note">Médiation : conformément à l'article L.612-1 du Code de la consommation, TremorApp adhère à un service de médiation. Les coordonnées du médiateur compétent sont disponibles sur demande à legal@tremor.fr.</div>

      <p style={{ textAlign: 'center', marginTop: '3rem', fontSize: '0.75rem', color: '#9A917F' }}>
        Document mis à jour le 15 mars 2026 — Version 1.0
      </p>
    </LegalPage>
  )
}
